const VALUE_SUFFIX = '_VALUE';

type TFeedConfig = {
  prefix: string;
  favoriteField: string;
};

const FEED_CONFIGS: TFeedConfig[] = [
  { prefix: 'L1PAGE_FEED', favoriteField: 'isFavorite' },
  { prefix: 'HOMEPAGE_FEED', favoriteField: 'isFavorited' },
];

export default function updateFeedSessionFavorite(itemId: string, isFavorite: boolean): void {
  const allKeys: string[] = [];
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key) allKeys.push(key);
  }

  for (const { prefix, favoriteField } of FEED_CONFIGS) {
    const keysToUpdate = allKeys
      .filter((k) => k.startsWith(prefix) && k.endsWith(VALUE_SUFFIX))
      .reduce<Array<{ key: string; data: { feedItemsPage: number; feedItems: Array<Record<string, unknown>> } }>>(
        (acc, k) => {
          try {
            const data = JSON.parse(sessionStorage.getItem(k) ?? '');
            if (Array.isArray(data?.feedItems) && data.feedItems.some((item) => item.itemId === itemId)) {
              acc.push({ key: k, data });
            }
          } catch {}
          return acc;
        },
        [],
      );

    for (const { key, data } of keysToUpdate) {
      try {
        sessionStorage.setItem(
          key,
          JSON.stringify({
            ...data,
            feedItems: data.feedItems.map((item) =>
              item.itemId === itemId ? { ...item, [favoriteField]: isFavorite } : item,
            ),
          }),
        );
      } catch {}
    }
  }
}
